export default __webpack_public_path__ + "static/media/mp4.c9ba73d8.svg";